import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-credit-card-conversion-learn-more',
  templateUrl: './credit-card-conversion-learn-more.component.html',
  styleUrls: ['./credit-card-conversion-learn-more.component.scss'],
  standalone: false,
})
export class CreditCardConversionLearnMoreComponent {
  @Input() contentLearnMore : any;
}